import {http} from '../../axios'

const mutationsSubscribeNames = [
  'setInputValue'
]

function getInitState() {
  return {
    muted: false,
    mutationsSubscribeNames,
    pendingLoad: false,
    inputs: {
      char_salary_type_id: {
        value: null
      },
      char_salary_payout: {
        value: null
      },
      char_salary_prepaid: {
        value: null
      },
      char_salary_comment: {
        value: null
      },
    }
  }
}

export default {
  namespaced: true,
  state: {
    ...getInitState(),
    salaryList: [],
    payoutList: [],
    prepaidList: [],
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setPendingLoad(state, value) {
      state.pendingLoad = value
    },
    setSalaryList(state, data) {
      state.salaryList = data
    },
    setPayoutList(state, data) {
      state.payoutList = data
    },
    setPrepaidList(state, data) {
      state.prepaidList = data
    },
    setInputValue(state, {key, value}) {
      if (!state.inputs.hasOwnProperty(key)) return
      state.inputs[key].value = value
    }
  },
  actions: {
    load({dispatch, commit}) {
      commit('setPendingLoad', true)

      Promise.all([
        dispatch('loadSalary'),
        dispatch('loadPayout'),
        dispatch('loadPrepaid')
      ]).then(() => {
        dispatch('setValueFromLists')
      }).finally(() => {
        commit('setPendingLoad', false)
      })
    },
    loadSalary({commit}) {
      return http.get('/api/helper/selectbox/salary_select_1').then(({data}) => {
        commit('setSalaryList', data.data)
      })
    },
    loadPayout({commit}) {
      return http.get('/api/helper/selectbox/salary_payout_frequency').then(({data}) => {
        commit('setPayoutList', data.data)
      })
    },
    loadPrepaid({commit}) {
      return http.get('/api/helper/selectbox/salary_prepaid').then(({data}) => {
        commit('setPrepaidList', data.data)
      })
    },
    setValueFromLists({state, commit}) {
      const keys = {
        'char_salary_type_id': 'salaryList',
        'char_salary_payout': 'payoutList',
        'char_salary_prepaid': 'prepaidList'
      }

      for (let [key, listKey] of Object.entries(keys)) {
        if (!isNaN(state.inputs[key].value)) {
          let value = state[listKey].find(item => item.id === state.inputs[key].value)
          if(value) commit('setInputValue', {key, value})
        }
      }

      commit('setMuted', false)
    },
    setVacancyValues({state, commit, dispatch}, vacancy) {
      for (let key in state.inputs) {
        commit('setInputValue', {key, value: vacancy[key]})
      }

      dispatch('setValueFromLists')
    }
  }
}
